import _ from 'lodash';
import { useContext } from 'react';
import moment from 'moment';
import classNames from 'classnames';

import { runPropTypes } from 'common/propTypes.js';
import Money from 'common/components/MoneyDisplay';
import SmallInfoCard from 'common/components/SmallInfoCard';
import { RUN_TYPES } from 'common/constants/index';
import { OrderContext } from '../../OrderStore/index';

const propTypes = {
  run: runPropTypes.isRequired
};


const getFormattedDate = (date) => moment(date).format('MMM Do YYYY');

const RunDetail = ({ run }) => {
  const {
    run_type: runType, start_date: startDate, end_date: endDate, order_type: orderType, status
  } = run;
  const { live, historic } = RUN_TYPES;

  const { overallProfit, isLoading } = useContext(OrderContext);

  const profit = isLoading ? 0 : overallProfit;

  const profitLossLabel = profit < 0 ? 'Loss' : 'Profit';
  const profitLossTitle = runType === live
    ? `Completed Transactions ${profitLossLabel}`
    : profitLossLabel;

  // Profit Loss icon
  const profitLossIconClassName = classNames(
    {
      'fa-regular fa-chart-line text-success tx-18': profitLossLabel === 'Profit',
      'fa-sharp fa-regular fa-chart-line-down text-danger tx-18': profitLossLabel === 'Loss'
    }
  );

  const orderTypeClassName = classNames(
    'main-head',
    orderType === 'actual'
      ? 'text-success'
      : 'text-info'
  );

  const orderTypeIconClassName = classNames(
    'fa-regular fa-file-lines tx-18',
    orderType === 'actual'
      ? 'text-success'
      : 'text-info'
  );

  const isDarkThemedStatus = (
    status === 'queued'
      || status === 'hopping'
      || status === 'starting'
      || status === 'paused'
      || status === 'server_stop'
  );

  const statusClassName = classNames(
    'main-head',
    {
      'text-dark': isDarkThemedStatus,
      'text-info': status === 'started',
      'text-success': status === 'completed' || status === 'stopped',
      'text-danger': status === 'errored' || status === 'killed' || status === 'day_squareoff'
    }
  );

  // Status icon
  const statusIconClassName = classNames(
    {
      'fa-sharp fa-regular fa-hourglass-clock text-dark tx-18': isDarkThemedStatus,
      'fa-regular fa-circle-play text-info tx-18': status === 'started',
      'fa-regular fa-circle-check text-success tx-18': status === 'completed' || status === 'stopped',
      'fa-regular fa-circle-check text-danger tx-18': status === 'day_squareoff',
      'fa-regular fa-circle-exclamation text-danger tx-18': status === 'errored' || status === 'killed'
    }
  );

  // Run type Icon
  const renderRunTypeIcon = () => (runType === historic
    ? <i className="fa-regular fa-clock-rotate-left tx-18"></i>
    : <i className="fa-regular fa-signal-stream tx-18"></i>
  );

  const alteredStatus = status === 'hopping' ? 'starting' : status;

  return (

    <div className="run-info mb-3">
      <SmallInfoCard
        infoAvatar={(
          <div className="info-avatar-custom">
            <i className={profitLossIconClassName} />
          </div>
        )}
        leftHeader={profitLossTitle}
        leftValue={
          isLoading ? <div>---</div> : <Money shouldColor>{profit}</Money>
        }
      />

      <SmallInfoCard
        infoAvatar={(
          <div className="info-avatar-custom">
            <div>{renderRunTypeIcon()}</div>
          </div>
        )}
        leftHeader="Run Type"
        leftValue={<div>{runType === 'historic' ? 'Historic' : 'Live'}</div>}
      />

      {runType === 'historic'
        ? (
          <SmallInfoCard
            infoAvatar={(
              <div className="info-avatar-custom">
                <span className="material-icons-outlined">date_range</span>
              </div>
            )}
            leftHeader="From"
            leftValue={<div>{getFormattedDate(startDate)}</div>}
            rightHeader="To"
            rightValue={<div>{getFormattedDate(endDate)}</div>}
          />
        )
        : (
          <SmallInfoCard
            infoAvatar={(
              <div className="info-avatar-custom">
                <i className={orderTypeIconClassName} />
              </div>
            )}
            leftHeader="Order Type"
            leftValue={<div className={orderTypeClassName}>{orderType}</div>}
          />
        )}

      <SmallInfoCard
        infoAvatar={(
          <div className="info-avatar-custom">
            <i className={statusIconClassName} />
          </div>
        )}
        leftHeader="Status"
        leftValue={<div className={statusClassName}>{_.startCase(alteredStatus)}</div>}
      />
    </div>
  );
};

RunDetail.propTypes = propTypes;

export default RunDetail;
